import { Capacitor } from '@capacitor/core';

const recentReports = new Map();
let installed = false;

function apiBaseUrl() {
  const configured = process.env.REACT_APP_API_URL || process.env.VITE_API_URL;
  if (configured) return configured.replace(/\/$/, '');
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform() === 'android'
      ? 'http://10.0.2.2:8000/api'
      : 'http://localhost:8000/api';
  }
  return `${window.location.protocol}//${window.location.hostname}:8000/api`;
}

function safePath(value) {
  try {
    return new URL(value || window.location.href, window.location.href).pathname;
  } catch (error) {
    return window.location.pathname;
  }
}

export function reportFrontendError({ category, code, description, path, details = {} }) {
  if (!category || !code || !description) return;
  const payload = {
    category,
    code: String(code).toUpperCase().replace(/[^A-Z0-9_.-]/g, '_').slice(0, 64),
    description: String(description).slice(0, 500),
    path: safePath(path),
    details: {
      ...details,
      browser: navigator.userAgent.slice(0, 300),
    },
  };
  const fingerprint = `${payload.category}|${payload.code}|${payload.path}|${payload.description}`;
  const now = Date.now();
  if (now - (recentReports.get(fingerprint) || 0) < 30000) return;
  recentReports.set(fingerprint, now);

  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('accessToken');
  if (token) headers.Authorization = `Bearer ${token}`;
  fetch(`${apiBaseUrl()}/monitoring/frontend-errors/`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}

export function installGlobalErrorReporting() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    const resource = event.target;
    if (resource && resource !== window && resource.tagName) {
      reportFrontendError({
        category: 'frontend_resource',
        code: 'RESOURCE_LOAD_ERROR',
        description: `Failed to load ${resource.tagName.toLowerCase()} resource.`,
        path: resource.src || resource.href || window.location.pathname,
      });
      return;
    }
    reportFrontendError({
      category: 'frontend_runtime',
      code: event.error?.name || 'JS_ERROR',
      description: event.message || 'An unexpected browser error occurred.',
      path: window.location.pathname,
      details: {
        filename: safePath(event.filename),
        line: event.lineno,
        column: event.colno,
      },
    });
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportFrontendError({
      category: 'frontend_runtime',
      code: reason?.name || 'UNHANDLED_PROMISE_REJECTION',
      description: reason?.message || String(reason || 'An unhandled promise was rejected.'),
      path: window.location.pathname,
    });
  });
}
